import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import ModelFormik from './ModelFormik'

export default class EditModelModal extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <ModelFormik title='EDIT MODEL' setting={{ make: 'Audi', model: 'A3', id: 1 }}>
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </ModelFormik>
          </div>
        </div>
      </Modal>
    )
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/model')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/EditModelModal.tsx